module.exports = __webpack_public_path__ + "static/img/quopay_b.ef66e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/present/quopay_b.png
// module id = rIfd
// module chunks = 0